export default __webpack_public_path__ + "d8474fbd05291b9b8fbfcb64131a3aec.png";